import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Alert } from "react-bootstrap";

interface DommusAlertaAmareloProps {
    mensagem: string
    classe?: string
    variant?: string
    icone?: IconProp
}

export function DommusAlertaAmarelo({ mensagem, classe, variant='warning', icone=faExclamationTriangle as IconProp }: DommusAlertaAmareloProps) {
    return (
        <Alert variant={variant} className={classe}>
            <FontAwesomeIcon icon={icone}/> {mensagem}
        </Alert>
    )
}